import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Workflow, ArrowDown, PlayCircle } from "lucide-react";

export default function AutomationsPage() {
    const q = useQuery({ queryKey: ["automations"], queryFn: () => api.get("/automations").then((r) => r.data) });
    const items = q.data || [];
    return (
        <div className="space-y-6 pv-enter">
            <div>
                <div className="pv-eyebrow mb-2">Automations</div>
                <h1 className="pv-serif text-4xl tracking-tight">Il lavoro che si fa da solo.</h1>
                <p className="text-[13.5px] text-textmuted mt-2 max-w-2xl">
                    Quando succede qualcosa, la piattaforma reagisce. Ogni automazione ricorda, invia, notifica e assegna in autonomia.
                </p>
            </div>

            <div className="grid lg:grid-cols-2 gap-4">
                {items.map((a) => (
                    <div key={a.id} className="pv-card p-6 pv-hover">
                        <div className="flex items-center justify-between mb-3">
                            <div className="flex items-center gap-2">
                                <div className="h-9 w-9 rounded-xl bg-primary/[0.08] flex items-center justify-center">
                                    <Workflow size={15} strokeWidth={1.5} className="text-primary" />
                                </div>
                                <div>
                                    <div className="text-[14px] font-medium">{a.name}</div>
                                    <div className="text-[11px] text-textsubtle">Trigger: {a.trigger}</div>
                                </div>
                            </div>
                            <span className={`text-[11px] px-2 py-0.5 rounded-md ${a.active ? "bg-success/10 text-success" : "bg-textsubtle/10 text-textmuted"}`}>
                                {a.active ? "Attiva" : "Off"}
                            </span>
                        </div>
                        <div className="space-y-2">
                            {a.steps.map((s, i) => (
                                <div key={i}>
                                    <div className="flex items-center gap-2.5 text-[12.5px]">
                                        <div className="h-6 w-6 rounded-lg bg-primary/[0.08] text-primary text-[10px] font-medium flex items-center justify-center flex-shrink-0">{i + 1}</div>
                                        <span>{s}</span>
                                    </div>
                                    {i < a.steps.length - 1 && (
                                        <div className="ml-3 h-3 border-l border-border/[var(--border-opacity)]"></div>
                                    )}
                                </div>
                            ))}
                        </div>
                        <div className="mt-4 pt-3 border-t border-border/[var(--border-opacity)] flex items-center justify-between text-[11px] text-textmuted">
                            <span>Eseguita <b className="text-textmain">{a.runs}</b> volte</span>
                            <span>Convertita <b className="text-success">{a.conversions}</b></span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
